const $ = require("jquery");

$(document).ready(function() {
  $(".header__location-switch__button").on("click", function() {
    $(this).toggleClass("header__location-switch__button--is-open");
    $(this)
      .siblings(".header__location-switch__menu")
      .toggleClass("header__location-switch__menu--is-visible");
  });
});
